export function setupToggles() {
  const toggles = Array.from(document.querySelectorAll('[data-toggle-id]'));
  toggles.forEach(toggle => {
    toggle.addEventListener('click', () => {
      const dropdown = document.getElementById(toggle.dataset.toggleId);
      toggle.classList.toggle('icon-invert');
      dropdown.classList.toggle('toggle-close');
    });
  });
}
